// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(value) {
  switch (value) {
    case "failed" :
        return /* Failed */1;
    case "na" :
        return /* NA */2;
    case "passed" :
        return /* Passed */0;
    default:
      return ErrorUtils$Catalyst.raiseError("BreachInfoThreshold.re", "Not a valid breach threshold value", value);
  }
}

function toString(value) {
  switch (value) {
    case /* Passed */0 :
        return "passed";
    case /* Failed */1 :
        return "failed";
    case /* NA */2 :
        return "na";
    
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

export {
  fromString ,
  toString ,
  t_decode ,
  
}
/* No side effect */
